import Model, { attr } from '@ember-data/model';

export default class AirbnbQualityStatListingModel extends Model {
  @attr('number') airbnbOfficialLinkId!: number;
  @attr('number') propertyId!: number;
  @attr('number') months!: number;
  @attr('number') overallIssueTripRate!: number | null;
  @attr('number') hostCancellationRate!: number | null;
  @attr('number') cancellationsByHost!: number;
  @attr('number') tripsCsReportHighSeverity!: number;
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'airbnb-quality-stat-listing': AirbnbQualityStatListingModel;
  }
}
